
export interface Opciones {
  Value: number;
  Text: string;
  IdComponente: number;
}
export interface Preguntas {
  id: number;
  IdComponente: number;
  descripcion: string;
  IdFormulario: number;
  estado: number;
  requerido: boolean;
  ThroughOf: string;
  depende_de: number;
  detalle: string;
  opciones: Opciones[];
}
export interface FormsResult {
  id: number;
  descripcion: string;
  estado: number;
  orden: number;
  preguntas: Preguntas[];
}

export interface QuestionAnswer {
  QuestionId: number;
  AnswerId?: number;
  ComponentId: number;
  Answer?: string;
}

export interface FormAnswerPayload {
  FormId: number;
  RegisterId?: number;
  RegisterType: number;
  FormType: number;
  RegisterResolvedBy: string;
  ResolvedQuestions: any[];
  Token: string;

}

export enum ComponentId {
  "text" = 1,
  "file" = 2,
  "number" = 3,
  "date" = 4,
  "checkbox" = 5,
  "radio" = 6,
  "select" = 7,
  "email" = 8,
  "textarea" = 9,

}